module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/download-light-67a6369336a61eb9621d199046ba736d.svg";